import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:w-[35%] mdlg:w-[40%] h-auto bg-white rounded-md flex flex-col space-y-6 px-6 py-6 shadow-md" }
const _hoisted_2 = { class: "w-full flex flex-row items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Forgot Password ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "w-full flex flex-col space-y-4" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Email ")
const _hoisted_7 = { class: "w-full flex flex-col pt-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Send Reset Link ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_roof_icon = _resolveComponent("roof-icon")!
  const _component_roof_header_text = _resolveComponent("roof-header-text")!
  const _component_roof_text_field = _resolveComponent("roof-text-field")!
  const _component_roof_button = _resolveComponent("roof-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.Logic.Common.goBack())),
        class: "h-[38px] w-[38px] rounded-full border-[1px] border-gray-800 flex items-center justify-center cursor-pointer"
      }, [
        _createVNode(_component_roof_icon, {
          name: "angle-small-left",
          "custom-class": "h-[21px]"
        })
      ]),
      _createVNode(_component_roof_header_text, {
        size: 'xl',
        customClass: '!font-extrabold'
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_roof_text_field, {
        placeholder: 'Enter your email',
        "has-title": true,
        padding: 'px-3 py-4',
        customClass: 'bg-gray-100 !rounded-md'
      }, {
        title: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_roof_button, { padding: 'py-4' }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      })
    ])
  ]))
}